import { useGetActiveContentBlock } from "./useGetActiveContentBlock";

export function useGetActiveContentBlockId() {
    const { data: activeContentBlock } = useGetActiveContentBlock();
    return activeContentBlock?.id ?? "";
}
